// useEditOrganization.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editOrganization as editOrganizationApi } from '../services/apiUsers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useEditOrganization() {
  const queryClient = useQueryClient();

  const { isLoading: isEditingOrg, mutate: editOrganization } = useMutation({
    mutationFn: (updatedOrg: { name: string; address: string; phone: string; email: string; orgId: string }) =>
      editOrganizationApi(updatedOrg.name, updatedOrg.address, updatedOrg.phone, updatedOrg.email, updatedOrg.orgId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast('success', 'Organization updated successfully!');
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`);
    },
  });

  return { isEditingOrg, editOrganization };
}

